import React from 'react';
import { Table } from 'react-bootstrap';
import { FEATURE_SECTIONS, PLAN_LIMITS, formatLimit } from '../../data/planFeaturesMatrix';

// Comparative features/limits table - same content as the "Plan y uso" tab in
// Parrotfy (see planFeaturesMatrix.js for the hardcoded mirror).
const CheckCell = ({ included, pro }) => (
  <td className={`text-center ${pro ? 'pf-col--pro' : ''}`}>
    {included ? (
      <span className="onboarding-features-table__check" aria-label="Incluido">
        ✓
      </span>
    ) : (
      <span className="onboarding-features-table__dash" aria-label="No incluido">
        -
      </span>
    )}
  </td>
);

const OnboardingPlanFeaturesTable = () => (
  <div className="onboarding-features-table">
    <h2 className="onboarding-features-table__title">Compara todos los detalles</h2>
    <p className="onboarding-features-table__intro">Todo lo que incluye cada plan, lado a lado.</p>
    <div className="table-responsive">
      <Table size="sm" className="mb-0">
        <thead>
          <tr>
            <th>Funcionalidad</th>
            <th className="text-center">Starter</th>
            <th className="text-center pf-col--pro">Pro</th>
            <th className="text-center">Business</th>
          </tr>
        </thead>
        <tbody>
          {FEATURE_SECTIONS.map(section => (
            <React.Fragment key={section.key}>
              <tr className="onboarding-features-table__section">
                <td colSpan={4}>{section.label}</td>
              </tr>
              {section.features.map(feature => (
                <tr key={feature.code}>
                  <td>{feature.label}</td>
                  <CheckCell included={feature.starter} />
                  <CheckCell included={feature.pro} pro />
                  <CheckCell included={feature.business} />
                </tr>
              ))}
            </React.Fragment>
          ))}
          <tr className="onboarding-features-table__section">
            <td colSpan={4}>Límites del plan</td>
          </tr>
          {PLAN_LIMITS.map(limit => (
            <tr key={limit.code}>
              <td>{limit.label}</td>
              <td className="text-center">{formatLimit(limit.starter)}</td>
              <td className="text-center pf-col--pro">{formatLimit(limit.pro)}</td>
              <td className="text-center">{formatLimit(limit.business)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  </div>
);

export default OnboardingPlanFeaturesTable;
